import $ from 'jquery';
import lozad from 'lozad';
import LinkController from './LinkController';
import ImageCreditsController from './ImageCreditsController.js';
import {CookiesController} from '../CookiesController.js';

class LazyLoadingController {
    constructor(scrollingContentID, totalPages, btnLoadMore, textBackgroundColor, key, restorePageState = false) {
        this.lastScroll = 0;
        this.totalPages = totalPages; // provided from the back end PagerControl.PageCount
        this.currentPage = 0;
        this.url = ''; // url of the page including any params
        this.nextDataPage = 0; // replaced when loading more
        this.prevDataPage = 0; // replaced when loading more
        this.nextDataCache = '';
        this.isLoading = false; // simple lock to prevent loading when loading
        this.scrollingContent = `#${scrollingContentID}`;
        this.textBackgroundColor = textBackgroundColor;
        this.btnLoadMore = btnLoadMore;
        this.restorePageState = restorePageState;
        this.key = key;

        $(this.scrollingContent).find('.PagerControl').addClass("hidden");
        this.InitLazyLoad();
    }

    storePageState(page) {
        CookiesController.createSOSCookie("latestnews", "paging_" + window.location.pathname + this.scrollingContent, page, -1);
    }

    getLastPage() {
        const page = CookiesController.readSOSCookie("latestnews", "paging_" + window.location.pathname + this.scrollingContent);
        if (typeof page === "undefined" || !page)
            return 0;
        const iPage = parseInt(page);
        if (isNaN(iPage))
            return 0;
        return iPage;
    }

    loadPages(firstPage, lastPage) {
        let currPage = firstPage;
        $(`${this.scrollingContent} div.scrollingcontentblock:last`).after($(this.nextDataCache).hide().fadeIn());
        LinkController.registerClickEventForElement(`${this.scrollingContent} div.scrollingcontentblock:last`);
        if (currPage <= lastPage) {
            const that = this;
            this.loadPage(currPage, function() {
                currPage += 1;
                if (currPage <= lastPage) {
                    that.loadPages(currPage, lastPage);
                }
            })
        }
    }

    loadPage(page, callback) {
        let that = this;
        LatestNews.GetLatestNews(page, this.key, this.textBackgroundColor, (data) => { // eslint-disable-line no-undef
            // parse & append the data
            that.nextDataCache = LazyLoadingController.parseHTML(data, page + 1);
            // End loading
            that.isLoading = false;
            that.currentPage = page;
            const observer = lozad(); // lazy loads elements with default selector as '.lozad'
            observer.observe();
            if (that.currentPage >= that.totalPages) {
                $(that.btnLoadMore).hide();
            }
            this.addImageCredits();
            callback();
        }, (data) => {
            console.log(`GetLatestNews error: ${JSON.stringify(data)}`);
            callback();
        });
    }

    getTeasers() {
        /* eslint-disable-next-line */
        LatestNews.GetLatestNews(this.nextDataPage, this.key, this.textBackgroundColor, (data) => {
            // parse & append the data
            this.nextDataCache = LazyLoadingController.parseHTML(data, this.nextDataPage);
            // End loading
            this.isLoading = false;
            this.currentPage += 1;
            const observer = lozad(); // lazy loads elements with default selector as '.lozad'
            observer.observe();
            if (this.currentPage >= this.totalPages) {
                $(this.btnLoadMore).hide();
            }
        },
        (data) => {
            console.log(`GetLatestNews error: ${JSON.stringify(data)}`);
        },
        );
    }

    InitLazyLoad() {
        $(window).scroll(() => {
            this.scrollPos = $(window).scrollTop();
        });

        this.url = window.location.href;

        if (this.nextDataPage <= this.totalPages) {
            // Load next page into cache
            this.isLoading = true;
            this.nextDataPage = this.currentPage + 1;
            if (this.restorePageState) {                
                const lastPage = this.getLastPage();
                if (lastPage > 1)
                    this.loadPages(1, lastPage);
            }
            this.getTeasers();
        }
        else {
            $(this.btnLoadMore).hide();
        }

        // lazy button click to load more
        $(this.btnLoadMore).click(() => {
            if (!this.isLoading) {
                // append the cached next page
                $(`${this.scrollingContent} div.scrollingcontentblock:last`).after($(this.nextDataCache).hide().fadeIn());
                // parse links
                LinkController.registerClickEventForElement(`${this.scrollingContent} div.scrollingcontentblock:last`);
                this.addImageCredits();
                // then load the next cache
                this.nextDataPage = this.currentPage + 1;
                if (this.nextDataPage <= this.totalPages) {
                    // Load next page into cache
                    this.isLoading = true;
                    this.getTeasers();
                    this.storePageState(this.nextDataPage);
                }
                else {
                    $(this.btnLoadMore).hide();
                }
            }
        });
    }

    addImageCredits(){
        const elements = document.querySelectorAll(`${this.scrollingContent} div.scrollingcontentblock:last-child img[data-credit]`);
        elements.forEach((e) => {
            ImageCreditsController.createForElement(e);
        });
    }

    // Since the whole page is returned - we just need the new page data
    static parseHTML(data, pg) {
        let contents = data;
        // update the page num
        contents = $(`${contents}.scrollingcontentblock`).attr('data-page', pg);
        return contents;
    }

    static loadDynamicImages() {
        const observer = lozad();
        observer.observe();
    }

    static mostlyVisible(element) {
        // if ca 25% of element is visible
        const scrollPos = $(window).scrollTop();
        const windowHeight = $(window).height();
        const elTop = $(element).offset().top;
        const elHeight = $(element).height();
        const elBottom = elTop + elHeight;
        return elBottom - elHeight * 0.25 > scrollPos && elTop < scrollPos + 0.5 * windowHeight;
    }

    static init(scrollingContentID, totalPages, btnLoadMore, textBackgroundColor, key, restorePageState = false) {
        new LazyLoadingController(scrollingContentID, totalPages, btnLoadMore, textBackgroundColor, key, restorePageState); // eslint-disable-line no-new
    }
}

window.LazyLoadingController = LazyLoadingController;
export default LazyLoadingController;
